import { GoogleIcon, MicrosoftIcon } from './icons';

const SocialAuthButtons = () => {
  return (
    <div className="mt-6 grid grid-cols-2 gap-3">
      <button
        type="button"
        aria-label="Sign in with Google"
        className="cursor-pointer w-full flex justify-center items-center py-2.5 px-4 border border-gray-200 rounded-md shadow-sm bg-white hover:bg-gray-50"
      >
        <GoogleIcon className="h-5 w-5 text-gray-700" />
        <span className="ml-2 text-sm font-medium text-gray-700">Google</span>
      </button>
      <button
        type="button"
        aria-label="Sign in with Microsoft"
        className="cursor-pointer w-full flex justify-center items-center py-2.5 px-4 border border-gray-200 rounded-md shadow-sm bg-white hover:bg-gray-50"
      >
        <MicrosoftIcon className="h-5 w-5 text-gray-700" />
        <span className="ml-2 text-sm font-medium text-gray-700">Microsoft</span>
      </button>
    </div>
  );
};

export default SocialAuthButtons;
